import { render } from "./SettingsButton.vue?vue&type=template&id=6f4f8ec0&scoped=true"
const script = {}

import "./SettingsButton.vue?vue&type=style&index=0&id=6f4f8ec0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4f8ec0"]])

export default __exports__